import type { SVGProps } from "react";

/**
 * Hand-drawn-style food motif SVGs for the landing page.
 * Stroke uses currentColor so they pick up section accent tints.
 * Size via className (e.g. "h-8 w-8 text-mustard").
 */

type Props = SVGProps<SVGSVGElement>;

const baseProps = (props: Props) => ({
  viewBox: "0 0 64 64",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
  ...props,
});

export const Lemon = (props: Props) => (
  <svg {...baseProps(props)}>
    <ellipse cx="32" cy="32" rx="22" ry="16" transform="rotate(-25 32 32)" />
    <ellipse cx="32" cy="32" rx="14" ry="9" transform="rotate(-25 32 32)" />
    <path d="M32 23 L32 41 M23 27 L41 37 M24 35 L40 29" transform="rotate(-25 32 32)" />
  </svg>
);

export const Tomato = (props: Props) => (
  <svg {...baseProps(props)}>
    <circle cx="32" cy="36" r="20" />
    <path d="M22 18 L32 22 L42 18 M27 16 L32 22 L37 16 M32 22 L32 14" />
    <path d="M20 30 Q24 28 28 32" opacity="0.5" />
  </svg>
);

export const Herb = (props: Props) => (
  <svg {...baseProps(props)}>
    <path d="M32 56 C32 40 32 24 32 8" />
    <path d="M32 18 C24 18 20 22 20 28 C26 28 30 26 32 22" />
    <path d="M32 26 C40 26 44 30 44 36 C38 36 34 34 32 30" />
    <path d="M32 36 C24 36 20 40 20 46 C26 46 30 44 32 40" />
  </svg>
);

export const Whisk = (props: Props) => (
  <svg {...baseProps(props)}>
    <path d="M32 8 L32 32" />
    <ellipse cx="32" cy="44" rx="14" ry="16" />
    <path d="M22 36 C28 50 36 50 42 36 M18 42 C26 56 38 56 46 42 M32 30 L32 56" />
  </svg>
);

export const Garlic = (props: Props) => (
  <svg {...baseProps(props)}>
    <path d="M32 12 C32 8 30 6 28 8 M32 12 C32 8 34 6 36 8" />
    <path d="M32 12 C20 14 14 26 18 40 C20 50 26 56 32 56 C38 56 44 50 46 40 C50 26 44 14 32 12 Z" />
    <path d="M32 14 L32 54 M22 18 C20 30 22 44 28 54 M42 18 C44 30 42 44 36 54" opacity="0.6" />
  </svg>
);

export const Chilli = (props: Props) => (
  <svg {...baseProps(props)}>
    <path d="M14 50 C14 30 26 14 46 12 C44 30 32 50 14 50 Z" />
    <path d="M44 14 C46 10 50 8 54 10 C52 14 48 16 46 14" />
  </svg>
);

export const Bowl = (props: Props) => (
  <svg {...baseProps(props)}>
    <path d="M8 28 L56 28 C56 44 46 54 32 54 C18 54 8 44 8 28 Z" />
    <path d="M14 34 C14 42 22 48 32 48" opacity="0.5" />
    <path d="M20 22 C22 18 26 16 32 16 C38 16 42 18 44 22" />
  </svg>
);
